var render, staticRenderFns
import script from "./render-option.vue?vue&type=script&lang=js&"
export * from "./render-option.vue?vue&type=script&lang=js&"
import style0 from "./render-option.vue?vue&type=style&index=0&id=8e81f492&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e81f492",
  null
  
)

export default component.exports